﻿/**
 * Compares two arrays of objects based on certain properties.
 * @param array1 - The first array of objects.
 * @param array2 - The second array of objects.
 * @param properties - The properties to be used for comparison.
 * @returns A boolean value indicating whether both arrays have at least one object that matches based on the specified properties.
 */
const compareArrays = <T>(array1: T[], array2: T[], properties: (keyof T)[]): boolean =>
    array1.some((item1) => array2.some((item2) => properties.every((property) => item1[property] === item2[property])));

export default compareArrays;
